/**
 * Core business order statuses (derived from Store Business Core audit).
 */

export const ORDER_STATUS = Object.freeze({
  PENDING: 'pending',
  ON_HOLD: 'on-hold',
  CONFIRMED: 'sbc-confirmed',
  PREPARING: 'sbc-preparing',
  SHIPPED: 'sbc-shipped',
  DELIVERED: 'sbc-delivered',
  REFUSED: 'sbc-refused',
  CANCELLED: 'cancelled',
  FAILED: 'failed',
  REFUNDED: 'refunded',
});

export const ORDER_STATUS_LABELS = Object.freeze({
  [ORDER_STATUS.PENDING]: { fr: 'En attente', ar: 'قيد الانتظار' },
  [ORDER_STATUS.ON_HOLD]: { fr: 'À confirmer', ar: 'في انتظار التأكيد' },
  [ORDER_STATUS.CONFIRMED]: { fr: 'Confirmée', ar: 'مؤكدة' },
  [ORDER_STATUS.PREPARING]: { fr: 'En préparation', ar: 'قيد التحضير' },
  [ORDER_STATUS.SHIPPED]: { fr: 'Expédiée', ar: 'تم الشحن' },
  [ORDER_STATUS.DELIVERED]: { fr: 'Livrée', ar: 'تم التوصيل' },
  [ORDER_STATUS.REFUSED]: { fr: 'Refusée', ar: 'مرفوضة' },
  [ORDER_STATUS.CANCELLED]: { fr: 'Annulée', ar: 'ملغاة' },
  [ORDER_STATUS.FAILED]: { fr: 'Échouée', ar: 'فاشلة' },
  [ORDER_STATUS.REFUNDED]: { fr: 'Remboursée', ar: 'مسترجعة' },
});

export const ORDER_STATUS_COLORS = Object.freeze({
  [ORDER_STATUS.PENDING]: 'warning',
  [ORDER_STATUS.ON_HOLD]: 'warning',
  [ORDER_STATUS.CONFIRMED]: 'info',
  [ORDER_STATUS.PREPARING]: 'info',
  [ORDER_STATUS.SHIPPED]: 'purple',
  [ORDER_STATUS.DELIVERED]: 'success',
  [ORDER_STATUS.REFUSED]: 'danger',
  [ORDER_STATUS.CANCELLED]: 'danger',
  [ORDER_STATUS.FAILED]: 'danger',
  [ORDER_STATUS.REFUNDED]: 'neutral',
});

/**
 * Valid state transitions for the Cash-On-Delivery workflow.
 */
export const ALLOWED_STATUS_TRANSITIONS = Object.freeze({
  [ORDER_STATUS.PENDING]: [ORDER_STATUS.CONFIRMED, ORDER_STATUS.REFUSED, ORDER_STATUS.CANCELLED],
  [ORDER_STATUS.ON_HOLD]: [ORDER_STATUS.CONFIRMED, ORDER_STATUS.REFUSED, ORDER_STATUS.CANCELLED],
  [ORDER_STATUS.CONFIRMED]: [ORDER_STATUS.PREPARING, ORDER_STATUS.CANCELLED],
  [ORDER_STATUS.PREPARING]: [ORDER_STATUS.SHIPPED, ORDER_STATUS.CANCELLED],
  [ORDER_STATUS.SHIPPED]: [ORDER_STATUS.DELIVERED, ORDER_STATUS.REFUSED],
  [ORDER_STATUS.DELIVERED]: [],
  [ORDER_STATUS.REFUSED]: [],
  [ORDER_STATUS.CANCELLED]: [],
  [ORDER_STATUS.FAILED]: [],
  [ORDER_STATUS.REFUNDED]: [],
});

/**
 * Checks whether a status transition is permitted by the COD business matrix.
 *
 * @param {string} fromStatus
 * @param {string} toStatus
 * @returns {boolean}
 */
export function isValidStatusTransition(fromStatus, toStatus) {
  const allowed = ALLOWED_STATUS_TRANSITIONS[fromStatus];
  return Array.isArray(allowed) && allowed.includes(toStatus);
}
